import { render } from "./ConnectionIssueAndOrderNotFound.vue?vue&type=template&id=d2c497ca&scoped=true"
import script from "./ConnectionIssueAndOrderNotFound.vue?vue&type=script&lang=js"
export * from "./ConnectionIssueAndOrderNotFound.vue?vue&type=script&lang=js"

import "../style.scss?vue&type=style&index=0&id=d2c497ca&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2c497ca"]])

export default __exports__